module.exports = __webpack_public_path__ + "img/collected.7c5d06fd.svg";